import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function trackUsage({ slug, title, path, category }) {
  try {
    await api.post("/track", { slug, title, path, category });
  } catch (e) {
    // non-blocking analytics
  }
}

export async function getTrending(limit = 8) {
  try {
    const { data } = await api.get(`/trending?limit=${limit}`);
    return data;
  } catch (e) {
    return [];
  }
}
